import { css } from '@huspy/styled-system/css';

export const mainComponentStyles = {
  ctaContainer: css({ width: '100%' }),
  button: css({ width: '47%' }),
  strong: css({ fontWeight: 'bold', color: 'var(--mantine-color-text)' }),
};

export const responseCapturedComponentStyles = {
  icon: css({
    borderRadius: '50%',
    backgroundColor: '#10b981',
    color: '#fff',
    padding: '20px',
    margin: '0 auto',
  }),
  text: css({ textAlign: 'center' }),
};
